// Module
var code = "<div class=\"details-container\"> <div class=\"close_icon\" ng-click=\"cancel()\"></div> <p id=\"activity_description\" class=\"popup-title\">{{info}}</p> </div>";
// Exports
var _module_exports = code;;
var path = 'app/modals/info.modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;